// extracted by css-extract-rspack-plugin
export default {"popoverFrame":"popoverFrame-k5ZeX_","propTitle":"propTitle-lvJEyQ","contentWrap":"contentWrap-Jjn8pK"};